import { useLocation } from "react-router-dom";
import { connect } from "react-redux";
import { changeLoginModalDisplayAciton } from "./actions/authActions";
import { getToken } from "./utils";

function PrivateRoute({ children, changeLoginModalDisplayAciton }) {
  const location = useLocation();

  const token = getToken();
  if (token) {
    return children;
  }

  // Show the login modal
  changeLoginModalDisplayAciton("block");

  // Don't render anything, stay on the same page
  return null;
}

const mapStateToProps = (state) => ({
  userData: state.userData.userData,
});

export default connect(mapStateToProps, { changeLoginModalDisplayAciton })(
  PrivateRoute
);
